// Define product limits for each box here.
const config = [
  {
    handle: 'build-your-own-taste-of-home-box',
    required: ['BYO_Standard'],
    limits: [
      { tag: 'Cat_1', limit: 2 },
      { tag: 'Cat_2', limit: 1 },
      { tag: 'Cat_3', limit: 1 },
      { tag: 'Cat_4', limit: 1 },
      { tag: 'Cat_5', limit: 2 },
    ],
  },
  {
    handle: 'build-your-own-taste-of-home-extra-large-16-items',
    required: ['BYO_XL'],
    limits: [
      { tag: 'Cat_1', limit: 4 },
      { tag: 'Cat_2', limit: 2 },
      { tag: 'Cat_3', limit: 2 },
      { tag: 'Cat_4', limit: 4 },
      { tag: 'Cat_5', limit: 4 },
    ],
  },
]

// Variants to swap at certian weights:
export const swap = [
  {
    find: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zNjI1NTc2ODAxOTEwMA==',
    replace: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zNzA1MTM2OTc4MzQ1Mg==',
    weight: 2000,
  },
]

// These collections will appear on the upsell page.
export const upsell = ['best-sellers', 'new-arrivals', 'socks', 'aussie-gifts']

// Find a config by handle.
export const productConfig = handle =>
  config.find(product => product.handle === handle)
